module.exports = __webpack_public_path__ + "static/media/community.73d168ab.svg";